import { type ElementType } from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { BodyTextM } from "./Typography";

export enum TransactionTextVariant {
    Title = "title",
    Date = "date",
    Amount = "amount",
}

export const TransactionRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
    }),
);

export const TransactionIconWrapper = styled(Stack)({
    width: "2.4rem",
    minWidth: "2.4rem",
    flexShrink: 0,
});

export const TransactionContent = styled(Stack)({
    flexGrow: 1,
});

export const TransactionsContainer = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 4,
    }),
);

export const ShowAllButton = styled(Button)<{ component?: ElementType; to?: string }>(({ theme }) =>
    theme.unstable_sx({
        width: "fit-content",
        pl: 0,
        "&:link, &:visited": { color: "primary.main" },
    }),
);

export const TransactionIcon = styled(Stack)({
    "& svg": { width: "2.4rem", height: "2.4rem" },
});

export const TransactionText = styled(BodyTextM, {
    shouldForwardProp: (prop) => prop !== "variant",
})<{ variant: TransactionTextVariant }>(({ theme, variant }) =>
    theme.unstable_sx({
        mb: 0,
        ...(variant === TransactionTextVariant.Date
            ? {
                fontWeight: 400,
                fontSize: "1.4rem",
                lineHeight: 1.4,
                color: "grey.500",
            }
            : {}),
    }),
);
